module.exports = __webpack_public_path__ + "img/footer.0aadd35b.png";